import React from "react";
import { Link } from "react-scroll";
import styled from "styled-components";
import { primaryBtn } from "../styles/style";

const GradientButton = ({ to, name, type }) => {
  return (
    <>
      {type === "page" ? (
        <Link to={to} spy={true} smooth={true} offset={-10} duration={500}>
          <Button>{name}</Button>
        </Link>
      ) : (
        <a href={to} target="_blank" rel="noreferrer">
          <Button>{name}</Button>
        </a>
      )}
    </>
  );
};

const Button = styled(primaryBtn)`
  @media (max-width: 400px) {
    font-size: 1rem;
  }
`;
export default GradientButton;
